import CaptionLabel from "./CaptionLabel";

const ErrorLabel = ({ value }: { value: string }) => {
  return <CaptionLabel value={value} color="error" />;
};

export default ErrorLabel;
